



























import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import {Impressions, logout} from '@/api';
import ImpressionComponent from '@/components/ImpressionComponent.vue';

@Component({
    components: {
        'v-impression': ImpressionComponent,
    },
})
export default class ShareView extends Vue {
    private impression: Impressions | null = null;
    private title = '三行感想文';

    private mounted() {
        window.scrollTo(0, 0);
        this.load();
    }

    private load() {
        console.log('load');
        // 画像urlロード
        const id = this.$route.params.id;
        firebase.auth().signInAnonymously()
            .then((res) => {
                const imageRef = firebase.firestore().collection('impressions');
                return imageRef.where('id', '==', id).limit(1).get();
            })
            .then((snapshot) => {
                if (!snapshot.empty) {
                    snapshot.forEach((doc) => {
                        this.impression = doc.data() as Impressions;
                        setMeta(this.impression.image_url);
                    });
                } else {
                    console.log('not found');
                    logout();
                }
            })
            .catch((err) => {
                // console.log(err);
                logout();
            });

        // meta tag設定
    }

    private routeLogin() {
        logout();
    }
}
function setMeta(imageURL: string) {
    const qu = document.querySelector('meta[name="twitter:url"]');
    if (qu != null) {
        qu.setAttribute('content', location.href);
    }

    const qi = document.querySelector('meta[name="twitter:image"]');
    if (qi != null) {
        qi.setAttribute('content', imageURL);
    }

    const qd =  document.querySelector('meta[name="twitter:description"]');
    if (qd != null) {
        qd.setAttribute('content', 'test description');
    }
}
